import { render, staticRenderFns } from "./WhoIsWhoPreview.vue?vue&type=template&id=4e80bdfc&lang=pug&"
import script from "./WhoIsWhoPreview.vue?vue&type=script&lang=js&"
export * from "./WhoIsWhoPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports